// src/services/parlayEngine.ts
import { BasePick, Parlay, ParlayStatus, uid } from '../domain/types';

export const combineOdds = (odds: number[]): number =>
  odds.reduce((a, b) => a * b, 1);

export const combinedHitRate = (picks: BasePick[]): number => {
  if (picks.length === 0) return 0;
  // média ponderada pelo inverso da odd (proxy de confiança)
  const weights = picks.map(p => 1 / p.odds);
  const sumW = weights.reduce((a, b) => a + b, 0);
  return Math.round(picks.reduce((acc, p, i) => acc + (p.hitRatePct ?? 50) * weights[i] / sumW, 0));
};

export const buildParlay = (picks: BasePick[], stake: number): Parlay => {
  const now = new Date().toISOString();
  return {
    id: uid(),
    picks,
    combinedOdds: combineOdds(picks.map(p => p.odds)),
    combinedHitRate: combinedHitRate(picks),
    stake,
    potentialReturn: +(stake * combineOdds(picks.map(p => p.odds))).toFixed(2),
    status: ParlayStatus.PENDING,
    createdAt: now,
    updatedAt: now,
  };
};

export const validateParlay = (picks: BasePick[]): { ok: boolean; error?: string } => {
  if (picks.length < 2) return { ok: false, error: 'Mínimo 2 pernas' };
  if (picks.length > 10) return { ok: false, error: 'Máximo 10 pernas' };
  // opcional: permitir apenas NBA+NHL misto ou mesmo esporte
  return { ok: true };
};
